import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchOffers } from "../services/api";
import ProductCard from "../components/ProductCard";
import styles from "./Offers.module.css";

export default function Offers() {
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOffers()
      .then((data) => setOffers(data.results || data))
      .catch(() => setOffers([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className={styles.page}>
      <div className="container">
        <div className={styles.header}>
          <span className="eyebrow">Private Selection</span>
          <h1>Offers Curated for You</h1>
          <p>Hand-picked pieces at exceptional value, based on your style.</p>
        </div>

        {loading && <p style={{ textAlign: "center", padding: 40 }}>Curating your offers…</p>}

        {!loading && (
          <div className={styles.grid}>
            {offers.map((offer) => (
              <ProductCard
                key={offer.id}
                product={{
                  id: offer.product,
                  name: offer.product_name,
                  emoji: offer.product_emoji,
                  image_url: offer.product_image,
                  description: "",
                  price: parseFloat(offer.original_price),
                }}
                discountedPrice={parseFloat(offer.discounted_price)}
                discountPercent={offer.discount_percent}
              />
            ))}
          </div>
        )}

        <div className={styles.actions}>
          <button className="btn-primary" onClick={() => navigate("/chat")}>
            Ask the Concierge
          </button>
          <button className="btn-secondary" onClick={() => navigate("/")}>
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
